import React from 'react'
import {Helmet} from 'react-helmet';
import SelectProjet from './Components/CreateProjet';

const CreateProjet = () => {
  return (
    
    <div>
      <Helmet>
        <title>Yash Admin Sales Management System</title>                                                                                                                                                                                                                                 
      </Helmet>
      <SelectProjet />
    </div>
  )
}

export default CreateProjet;